import { useState } from "react";
import { archiveTags } from "@/mocks/evidence";
import Reveal from "./Reveal";
import { SectionHeading } from "./Ui";

function sizeFor(heat: number): string {
  switch (heat) {
    case 5:
      return "bg-primary-600 text-background-50 hover:bg-primary-700";
    case 4:
      return "bg-accent-100 text-accent-900 border border-accent-200 hover:bg-accent-200";
    case 3:
      return "bg-secondary-100 text-secondary-800 border border-secondary-200 hover:bg-secondary-200";
    default:
      return "bg-background-50 text-foreground-700 border border-background-300 hover:bg-background-200/70";
  }
}

function scaleFor(heat: number): string {
  switch (heat) {
    case 5:
      return "text-sm md:text-base";
    case 4:
      return "text-sm md:text-[15px]";
    case 3:
      return "text-xs md:text-sm";
    default:
      return "text-xs md:text-sm";
  }
}

export default function Archive() {
  const [active, setActive] = useState<string>("");

  return (
    <section id="archive" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[380px_1fr]">
          <div>
            <SectionHeading
              eyebrow="Archive · 关键词归档"
              title="按关键词索引材料"
              desc="点击标签即可在证据库中快速定位相关内容。字号与底色代表该主题下的归档密度与热度。"
            />
            <div className="mt-2 inline-flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2 text-xs text-foreground-600">
              <i className="ri-focus-3-line flex h-4 w-4 items-center justify-center text-primary-600 text-base" />
              当前筛选：{active || "全部主题"}
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-2 md:justify-start">
            <button
              type="button"
              onClick={() => setActive("")}
              className={`whitespace-nowrap rounded-full px-4 py-2 transition-colors ${sizeFor(
                0
              )} ${active === "" ? "ring-2 ring-primary-400" : ""}`}
            >
              全部
            </button>
            {archiveTags.map((tag, idx) => (
              <Reveal key={tag.name} delay={(idx % 4) * 60}>
                <button
                  type="button"
                  onClick={() => setActive(active === tag.name ? "" : tag.name)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 font-medium transition-colors ${scaleFor(
                    tag.heat
                  )} ${sizeFor(tag.heat)} ${
                    active === tag.name ? "ring-2 ring-primary-400" : ""
                  }`}
                >
                  {tag.name}
                  <span className="ml-1.5 opacity-70">{tag.count}</span>
                </button>
              </Reveal>
            ))}
          </div>
        </div>

        <p className="mt-8 text-center text-xs text-foreground-500">
          词条热度由归档条目数动态生成，点击后在证据库筛选中保持为当前主题关键词。
        </p>
      </div>
    </section>
  );
}